import EntryScreen from "./landingScreens/entryScreen";
import React, { useEffect, useRef, useState } from "react";
import { Box, styled } from "@mui/system";
import { IconButton, Typography } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TopBar from "./landingComponents/topBar";
import useObjectState from "../../utils/useObjectState";
import ChangeLogScreen from "./landingScreens/changeLogScreen";

export default function LandingPage() {
  const [isVisible, setIsVisible] = useState(false);
  const [state, setState] = useObjectState({ pageTab: "entry" });
  const handleScroll = () => {
    if (window.scrollY > 20) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const getPage = (tab) => {
    return {
      entry: <EntryScreen />,
      changelog: <ChangeLogScreen />,
    }[tab];
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Background>
          <TopBar setState={setState} />
          {getPage(state.pageTab)}
          <BottomSection>
            <Typography variant='body2' color='white' component='p'>
              © 2025 by 8p.hk
            </Typography>
          </BottomSection>
        </Background>
        <BackToTopButton
          onClick={scrollToTop}
          style={{
            display: isVisible ? "block" : "none",
          }}
        />
      </div>
    </>
  );
}

const Background = styled("div")({
  margin: 0,
  padding: 0,
  width: "100%",
  height: "100vh",
});

const BackToTopButton = ({ onClick, style }) => (
  <IconButton
    title='Go to top'
    onClick={onClick}
    style={{
      position: "fixed",
      bottom: "20px",
      right: "30px",
      zIndex: 99,
      border: "none",
      outline: "none",
      backgroundColor: "#555",
      color: "white",
      cursor: "pointer",
      padding: "10px",
      borderRadius: "50%",
      fontSize: "10px",
      ":hover": {
        backgroundColor: "#777",
        transition: 1,
      },
      ...style,
    }}
  >
    <KeyboardArrowUpIcon />
  </IconButton>
);

const BottomSection = styled(Box)(({ theme }) => ({
  backgroundColor: "#272727",
  padding: theme.spacing(4),
  height: "50vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
}));
